import './new-department.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateDepartment } from "@core/query/department.query";
import { DepartmentFormRule, DepartmentFormSchema } from "@core/form/form.rule";
import { departmentFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormDepartment from "../form-department/form-department";

export function Department() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateDepartment } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Department is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addDepartment, isLoading: isCreating } =
    useQyCreateDepartment(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<DepartmentFormSchema>({
    defaultValues: departmentFormDefault,
    resolver: zodResolver(DepartmentFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: DepartmentFormSchema) => {
    const formData = mapCreateDepartment(form);
    addDepartment(formData);
  };
  const handleValidateError = (err: FieldErrors<DepartmentFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="Department" className="department">
      <HeaderContent
        title="New Department"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormDepartment />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default Department;